import React, { useState } from "react";
import {
    AppBar,
    Box,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
    Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const options = [
    { display: "РКО", value: "rko" },
    { display: "Чек", value: "receipt" },
    { display: "Перевод", value: "transfer" },
];

const TypeInput = ({ value, onChange }) => {
    const [selectedValue, setSelectedValue] = useState(value || null); // Текущее выбранное значение
    const navigate = useNavigate(); // Для навигации

    const handleListItemClick = (option) => {
        setSelectedValue(option); // Устанавливаем выбранное значение
        if (onChange) {
            onChange(option); // Передаем значение родительскому компоненту
        }
    };

    const handleSave = () => {
        if (onChange) {
            onChange(selectedValue);
        }
        navigate(-1); // Возвращаемся назад
    };

    const handleBack = () => {
        navigate(-1); // Переход на предыдущую страницу
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            {/* Верхняя панель */}
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-display="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Выберите тип
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Список типов */}
            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                <List component="nav" aria-display="type-options">
                    {options.map((option) => (
                        <ListItemButton
                            key={option.value}
                            selected={selectedValue === option.value} // Подсвечиваем выбранный элемент
                            onClick={() => handleListItemClick(option)}
                        >
                            <ListItemText primary={option.display} />
                        </ListItemButton>
                    ))}
                </List>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={handleSave}
                    disabled={!selectedValue} // Кнопка неактивна, если ничего не выбрано
                >
                    Сохранить
                </Button>
            </Box>
        </Box>
    );
};

export default TypeInput;
